<template>
  <div class="wrap">
    <!-- Loading -->
    <!-- <div v-if="loading" class="loading apollo">Loading...</div> -->

    <!-- Error -->
    <!-- <div v-else-if="error" class="error apollo">An error occurred</div> -->

    <!-- Result -->
    <div class="pre-header mb-2 full layout align-center">
      <div class="externalId">
        <span v-if="data">{{ data.externalId }}</span>
        <span v-else>Loading...</span>
      </div>

      <v-spacer />
      <div v-show="!hideMenu" class="menue">
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-icon @click.stop v-on="on">{{ icons.more }}</v-icon>
          </template>
          <asset-options
            v-if="data"
            :slide="data"
            :is-gold-slide="data.goldSlide"
            :will-delete="data.deletion.willDelete"
            :archive="data.inArchive"
            @update="getSlide()"
          />
        </v-menu>
      </div>
    </div>
    <div class="asset-title full">
      <span v-if="data">
        <clean-input
          :disabled="disableNameChange"
          :initial-value="data.name"
          :action="text => $store.dispatch('slides/updateActiveSlide', { name: text })"
        />
      </span>
      <div v-else class="loading">Loading...</div>
    </div>
    <div class="assigned align-center pr-2 layout">
      <assignment-boundary
        @reload="getSlide"
        v-if="data && !data.inArchive"
        :asset-id="data._id"
        :assignments="data.assignedTo"
      >
        <template v-slot:activator="{ on }">
          <assign class="assign" v-on="on" :assignedTo="data.assignedTo" />
        </template>
        <v-spacer />
      </assignment-boundary>
      <div class="layout align-center" v-if="data && data.inArchive">
        <v-icon color="secondary">mdi-archive</v-icon>
        <div class="ml-1 archive-info color--secondary">Archived</div>
      </div>
      <v-spacer />
      <status v-if="data" :slide-id="_id" :status-id="data.workflowStatus" :status="data.status" />
    </div>
    <!-- No result -->
    <!-- <div v-else class="no-result apollo">No result :(</div> -->
  </div>
</template>

<script>
import gql from 'graphql-tag';
import icons from '../../../mixins/icons';
import AssetHeaderMenuOptionsVue from './AssetHeaderMenuOptions.vue';
import StatusViewVue from '../../core/views/StatusView.vue';
import CleanInputVue from '../../core/inputs/CleanInput.vue';
import { slideQuery } from '@/services/graph/slide.graph';
import { EventBus } from '../../../event-bus';
import AssignmentBoundary from '../../../hoc/AssignmentBoundary.vue';
import AssignUserToSlide from '../../AssignUserToSlide.vue';
export default {
  name: 'AssetHeader',
  components: {
    assign: AssignUserToSlide,
    assetOptions: AssetHeaderMenuOptionsVue,
    status: StatusViewVue,
    cleanInput: CleanInputVue,
    assignmentBoundary: AssignmentBoundary
  },
  mixins: [icons],
  props: {
    _id: String,
    hideMenu: Boolean,
    disableNameChange: Boolean
  },
  data() {
    return {
      id: this._id,
      loading: false,
      error: false,
      data: null
    };
  },
  watch: {
    _id: {
      handler(newVal) {
        this.id = newVal;
        this.getSlide();
      }
    }
  },
  mounted() {
    this.getSlide();
    EventBus.$on('update-header', () => {
      this.getSlide();
    });
  },
  methods: {
    async getSlide() {
      this.loading = true;
      try {
        const data = await slideQuery(this.id);
        this.data = data;
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    onStatusChange(previousResult, { subscriptionData: { slideStatus } }) {}
  },
  query: {
    header: {
      query: gql`
        query header($id: ID!) {
          getSlide(id: $id) {
            goldSlide
            name
            status
            workflowStatus
            assignedTo {
              _id
              name
              email
            }
            deletion {
              willDelete
            }
            _id
            externalId
          }
        }
      `
    }
  }
};
</script>

<style scoped>
.loading {
  height: inherit;
  width: 100%;
}
.assigned {
  margin-top: 16px;
}
.wrap {
  min-height: 120px;
}
.header-input {
  outline: none;
}
.header-input:focus {
  border-bottom: 1px solid var(--lightish-blue);
}
.archive-info {
  color: rgb(222, 89, 90);
  font-weight: bold;
}
.assign {
  max-width: 60%;
  width: 55%;
  margin-right: 3px;
}
</style>
